import React from "react";
import "./BakeloreIntro.css";

const BakeloreIntro = () => {
  return (
    <div className="intro-container">
      {/* LEFT IMAGES */}
      <div className="intro-images">
        <img
          src="https://bakelore.com/images/cream-bun-bakelore.jpeg"
          alt="Bakelore Dessert"
          className="intro-img top-img"
        />
        <img
          src="https://bakelore.com/images/bun-bakelore.jpeg"
          alt="Bakelore Dessert"
          className="intro-img bottom-img"
        />
      </div>

      {/* RIGHT CONTENT */}
      <div className="intro-content">
        <h1 className="intro-title">
          Best Bakery in  Hyderabad
        </h1>

        <p className="intro-text">
          Welcome to Bakelore — a ’90s themed bakery bringing to the contemporary world,
          a nostalgic era of home-baked goodness in the most aesthetic way possible.
        </p>

        <p className="intro-text">
          Bakelore was founded with the aim of bringing scrumpdillylicious traditional
          baked goods to modern-day customers. We believe that good food should be made
          with the finest ingredients and from the finest memories of the ’90s with our families.
        </p>

        <a href="/about" class="intro-btn">READ MORE</a>

      </div>
    </div>
  );
};

export default BakeloreIntro;
